module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/announcement-bar/announcement-bar.component.scss
// module id = ./src/app/admin/announcement-bar/announcement-bar.component.scss
// module chunks = main